/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.support.portal.rpc.AttachmentsRpc
 */

export const ConsentErrorTypename = 'com.hubspot.portals.platform.models.rpc.ConsentError';
export const ConsentErrorDiscriminant = 'CONSENT';
export const ConsentErrorDiscriminantKey = '@type';
export const NotificationErrorTypename = 'com.hubspot.portals.platform.models.rpc.NotificationError';
export const NotificationErrorDiscriminant = 'NOTIFICATION';
export const NotificationErrorDiscriminantKey = '@type';
export const PortalAuthErrorTypename = 'com.hubspot.portals.platform.models.rpc.PortalAuthError';
export const PortalAuthErrorDiscriminant = 'AUTH';
export const PortalAuthErrorDiscriminantKey = '@type';
export const PortalPublicRpcErrorDiscriminantKey = '@type';
export const SettingsErrorTypename = 'com.hubspot.portals.platform.models.rpc.SettingsError';
export const SettingsErrorDiscriminant = 'SETTINGS';
export const SettingsErrorDiscriminantKey = '@type';
export const SupportPortalErrorTypename = 'com.hubspot.portals.platform.models.rpc.SupportPortalError';
export const SupportPortalErrorDiscriminant = 'SUPPORT_PORTAL';
export const SupportPortalErrorDiscriminantKey = '@type';
export const getUploadTokenRpc = {
  serviceName: 'com.hubspot.support.portal.rpc.AttachmentsRpc',
  rpcName: 'getUploadToken',
  auth: 'external',
  fingerprint: 'wZeC73pj5V06soe-lQ4sZ2qVobnnONkj',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getThreadAttachmentsRpc = {
  serviceName: 'com.hubspot.support.portal.rpc.AttachmentsRpc',
  rpcName: 'getThreadAttachments',
  auth: 'external',
  fingerprint: 'iGhH065w9_vOBnbx3Ebwm2qVobnnONkj',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};